import { Controller } from "@hotwired/stimulus"

const SEVERIDADE_CLASSES = {
  impeditivo: {
    border: ['border', 'border-l-4', 'border-red-500'],
    bg:     ['bg-red-50'],
    badge:  ['bg-red-600', 'text-white'],
    icon:   iconCircleX('text-red-600'),
  },
  alerta: {
    border: ['border', 'border-yellow-200'],
    bg:     ['bg-yellow-50'],
    badge:  ['bg-yellow-100', 'text-yellow-700'],
    icon:   iconWarning('text-yellow-500'),
  },
}

const TIPO_VISUAL_CLASSES = {
  restricao: {
    border: ['border', 'border-gray-200'],
    bg:     ['bg-gray-50'],
    badge:  ['bg-gray-200', 'text-gray-700'],
    icon:   iconBan('text-gray-500'),
    label:  'Restrição',
  },
  info: {
    border: ['border', 'border-blue-200'],
    bg:     ['bg-blue-50'],
    badge:  ['bg-blue-100', 'text-blue-700'],
    icon:   iconInfo('text-blue-500'),
    label:  'Informativo',
  },
}

const SEVERIDADE_LABEL = {
  impeditivo: 'Impeditivo',
  alerta:     'Atenção',
}

const AVISO_PREVIO_POR_TIPO = {
  pedido_colaborador:       ['trabalhado', 'indenizado'],
  demissao_sem_justa_causa: ['trabalhado', 'dispensado', 'indenizado'],
  justa_causa:              ['nao_aplicavel'],
  termino_experiencia:      ['nao_aplicavel'],
  antecipacao_experiencia:  ['trabalhado', 'indenizado'],
  acordo:                   ['trabalhado', 'dispensado', 'indenizado'],
  falecimento:              ['nao_aplicavel'],
}

const TIPOS_COM_JUSTIFICATIVA_OBRIGATORIA = ['justa_causa', 'demissao_sem_justa_causa', 'acordo']

const TIPOS_COM_MOTIVO_OBRIGATORIO = ['demissao_sem_justa_causa', 'justa_causa', 'antecipacao_experiencia', 'acordo', 'falecimento']

const TIPO_PARA_PREFIXO_DOC = {
  pedido_colaborador:       'cartaDemissao',
  demissao_sem_justa_causa: 'comunicadoDemissao',
  justa_causa:              'documentosJustaCausa',
  acordo:                   'documentosAcordo',
  falecimento:              'documentosFalecimento',
}

const PREFIXO_PARA_CAMPO_DOC = {
  cartaDemissao:        'carta_de_demissao',
  comunicadoDemissao:   'comunicado_demissao',
  documentosJustaCausa: 'documento_comprobatorio',
  documentosAcordo:     'termo_acordo',
  documentosFalecimento: 'certidao_obito',
}

const FGTS_POR_TIPO = {
  demissao_sem_justa_causa: '01',
  pedido_colaborador:       '',
  justa_causa:              '',
  termino_experiencia:      '05',
  antecipacao_experiencia:  '05',
  acordo:                   '07',
  falecimento:              '23',
}

const TIPOS_COM_CODIGO_FGTS = [
  'demissao_sem_justa_causa',
  'termino_experiencia',
  'antecipacao_experiencia',
  'acordo',
  'falecimento',
]

export default class extends Controller {
  static targets = [
    "step", "stepIndicator", "stepLabel",
    "btnProximo", "btnAnterior", "btnSubmit",
    "erroGlobal", "loadingIndicator",
    "formulario",
    // etapa 1
    "campoBusca", "funcionarioId", "tipoRescisao", "dataPretendida", "avisoPrevio", "observacoes",
    // etapa 2 - dados cadastrais / trabalhistas
    "dadosFuncionario", "alertaAfastamento", "textoSituacao", "consultadoEm",
    "dadoNome", "dadoCargo", "dadoAdmissao", "dadoTempoCasa", "dadoSituacao",
    "dadoFeriasVencidas", "dadoVencimentoFerias",
    // etapa 2 - financeiros
    "dadoSalario",
    "dadoVaRow", "dadoVa",
    "dadoVrRow", "dadoVr",
    "dadoCestaRow", "dadoCesta",
    "dadoVtRow", "dadoVt",
    "dadoFgts",
    // etapa 2 - alerta perda de benefícios (pedido_colaborador)
    "alertaBeneficiosContainer", "alertaBeneficiosList",
    // etapa 2 - alertas inline
    "semAlertas", "alertasContainer", "alertaTemplate",
    // etapa 3 - ciência formal
    "checkboxesContainer", "checkboxAlertaTemplate", "cienciaCheckbox",
    "justificativaContainer", "justificativa",
    // etapa 4 - resumo readonly topo
    "etapa4Resumo", "resumoTipo", "resumoData", "resumoAviso",
    "etapa4Alertas",
    "etapa4Impedimentos", "impedimentoFerias", "impedimentoBeneficios", "impedimentoConsignados",
    "verbasRescisoriasContainer",
    // etapa 4 - dados operacionais
    "codigoFgtsContainer", "codigoFgts",
    "motivoContainer", "motivoDetalhado", "motivoObrigatorio",
    "observacoesDp",
    // etapa 4 - descontos expandidos
    "descontoVtRow", "descontoVtCheckbox", "descontoVtValor", "descontoVtHint",
    "descontoVaRow", "descontoVaCheckbox", "descontoVaValor", "descontoVaHint",
    "descontoVrRow", "descontoVrCheckbox", "descontoVrValor", "descontoVrHint",
    "descontoOutros",
    // etapa 1 - guia do processo (um por tipo; mostra/oculta via #atualizaGuiaProcesso)
    "guiaProcesso",
    // etapa 3 - uploads por tipo (movidos da etapa 5)
    "cartaDemissaoSection", "cartaDemissaoInput", "cartaDemissaoExistente",
    "comunicadoDemissaoSection", "comunicadoDemissaoInput", "comunicadoDemissaoExistente",
    "documentosJustaCausaSection", "documentosJustaCausaInput", "documentosJustaCausaExistente",
    "documentosAcordoSection", "documentosAcordoInput", "documentosAcordoExistente",
    "documentosFalecimentoSection", "documentosFalecimentoInput", "documentosFalecimentoExistente",
    "encaminhamentoExameSection", "encaminhamentoExameInput",
    // etapa 5 - revisão
    "revisaoTipo", "revisaoDocVazio", "revisaoDocItem",
    "revisaoDocLabel", "revisaoDocNomeTexto", "revisaoDocLink",
    // hidden fields
    "preAnaliseJson", "alertasJson", "alertasExibidosJson",
    // footer
    "btnRascunho",
  ]

  static values = {
    etapa: { type: Number, default: 1 },
    preAnaliseUrl: String,
    docExistente: { type: String, default: '' },
    docExistenteUrl: { type: String, default: '' },
  }

  #alertas = []
  #preAnaliseSucesso = false
  #requerJustificativa = false
  #etapaMaxima = 1
  #avisoPrevioOpcoes = []
  #etapasVisitadas = new Set()
  #objectUrl = null

  connect() {
    this.#renderizaEtapa()
    if (this.hasAvisoPrevioTarget) {
      this.#avisoPrevioOpcoes = Array.from(this.avisoPrevioTarget.options)
        .map(o => ({ value: o.value, text: o.text }))
    }
    if (this.hasTipoRescisaoTarget) {
      this.#atualizaGuiaProcesso(this.tipoRescisaoTarget.value)
    }
  }

  disconnect() {
    if (this.#objectUrl) {
      URL.revokeObjectURL(this.#objectUrl)
      this.#objectUrl = null
    }
  }

  async avancar(event) {
    event.preventDefault()
    if (!this.#validaEtapaAtual()) return

    if (this.etapaValue === 1) {
      const ok = await this.#carregaPreAnalise()
      if (!ok) return
    }

    if (this.etapaValue < 5) {
      this.#etapasVisitadas.add(this.etapaValue)
      this.etapaValue++
      if (this.etapaValue > this.#etapaMaxima) this.#etapaMaxima = this.etapaValue
      if (this.etapaValue === 3) this.#preparaEtapa3Docs()
      if (this.etapaValue === 4) this.#preparaEtapa4()
      if (this.etapaValue === 5) this.#preparaRevisao()
      this.#renderizaEtapa()
    }
  }

  irParaEtapa(event) {
    const alvo = Number(event.currentTarget.dataset.etapa)
    if (alvo === this.etapaValue) return

    if (alvo < this.etapaValue || alvo <= this.#etapaMaxima) {
      this.#etapasVisitadas.add(this.etapaValue)
      this.etapaValue = alvo
      if (alvo === 3) this.#preparaEtapa3Docs()
      if (alvo === 4) this.#preparaEtapa4()
      if (alvo === 5) this.#preparaRevisao()
      this.#renderizaEtapa()
    } else {
      this.#exibeErro('Complete as etapas anteriores para avançar.')
    }
  }

  voltar(event) {
    event.preventDefault()
    if (this.etapaValue > 1) {
      this.#etapasVisitadas.add(this.etapaValue)
      this.etapaValue--
      this.#renderizaEtapa()
    }
  }

  verificaCiencia() {
    this.#atualizaBotaoSubmit()
  }

  salvarRascunho() {
    const form = this.formularioTarget
    let campo = form.querySelector('input[name="rascunho"]')
    if (!campo) {
      campo = document.createElement('input')
      campo.type  = 'hidden'
      campo.name  = 'rascunho'
      form.appendChild(campo)
    }
    campo.value = '1'
    form.submit()
  }

  atualizaAvisoPrevio() {
    const tipo       = this.tipoRescisaoTarget.value
    const permitidos = AVISO_PREVIO_POR_TIPO[tipo]
    const select     = this.avisoPrevioTarget
    const valorAtual = select.value

    const opcoes = permitidos
      ? this.#avisoPrevioOpcoes.filter(o => permitidos.includes(o.value))
      : this.#avisoPrevioOpcoes

    select.innerHTML = ''
    opcoes.forEach(({ value, text }) => {
      const opt = document.createElement('option')
      opt.value = value
      opt.text  = text
      select.appendChild(opt)
    })

    if (permitidos?.includes(valorAtual)) select.value = valorAtual

    this.#atualizaGuiaProcesso(tipo)
  }

  toggleGuiaProcesso(event) {
    const container = event.currentTarget.closest('[data-rescisoes--wizard-target="guiaProcesso"]')
    if (!container) return
    const content = container.querySelector('.guia-content')
    const chevron = container.querySelector('.guia-chevron')
    const aberto  = content && !content.classList.contains('hidden')
    if (content) content.classList.toggle('hidden', aberto)
    if (chevron) chevron.style.transform = aberto ? '' : 'rotate(180deg)'
  }

  // Habilita/desabilita input de valor ao marcar cada checkbox de desconto
  toggleDescontoVt() {
    if (this.hasDescontoVtValorTarget) {
      this.descontoVtValorTarget.disabled = !this.descontoVtCheckboxTarget.checked
    }
  }

  toggleDescontoVa() {
    if (this.hasDescontoVaValorTarget) {
      this.descontoVaValorTarget.disabled = !this.descontoVaCheckboxTarget.checked
    }
  }

  toggleDescontoVr() {
    if (this.hasDescontoVrValorTarget) {
      this.descontoVrValorTarget.disabled = !this.descontoVrCheckboxTarget.checked
    }
  }

  // ─── Private ─────────────────────────────────────────────────────────────

  #renderizaEtapa() {
    const etapa = this.etapaValue
    const total = this.stepTargets.length

    this.stepTargets.forEach(el => {
      el.classList.toggle('hidden', el.dataset.etapa !== String(etapa))
    })

    const BTN_ACTIVE     = ['bg-blue-600',   'text-white']
    const BTN_COMPLETE   = ['bg-green-600',  'text-white']
    const BTN_INCOMPLETE = ['bg-yellow-400', 'text-gray-900']
    const BTN_UNVISITED  = ['bg-gray-100',   'text-gray-500']
    const CIRCLE_LIGHT   = ['border-white',      'text-white']
    const CIRCLE_YELLOW  = ['border-yellow-200', 'text-gray-900']
    const CIRCLE_GRAY    = ['border-gray-400',   'text-gray-500']

    this.stepIndicatorTargets.forEach(btn => {
      const n      = Number(btn.dataset.etapa)
      const circle = btn.querySelector('.step-indicator-circle')
      if (!circle) return

      btn.classList.remove(...BTN_ACTIVE, ...BTN_COMPLETE, ...BTN_INCOMPLETE, ...BTN_UNVISITED)
      circle.classList.remove(...CIRCLE_LIGHT, ...CIRCLE_YELLOW, ...CIRCLE_GRAY)

      if (n === etapa) {
        btn.classList.add(...BTN_ACTIVE)
        circle.classList.add(...CIRCLE_LIGHT)
        circle.innerHTML = String(n)
      } else if (this.#etapasVisitadas.has(n)) {
        if (this.#etapaCompleta(n)) {
          btn.classList.add(...BTN_COMPLETE)
          circle.classList.add(...CIRCLE_LIGHT)
          circle.innerHTML = checkIcon()
        } else {
          btn.classList.add(...BTN_INCOMPLETE)
          circle.classList.add(...CIRCLE_YELLOW)
          circle.innerHTML = String(n)
        }
      } else {
        btn.classList.add(...BTN_UNVISITED)
        circle.classList.add(...CIRCLE_GRAY)
        circle.innerHTML = String(n)
      }
    })

    if (this.hasStepLabelTarget) {
      this.stepLabelTarget.textContent = `Etapa ${etapa} de ${total}`
    }

    this.btnAnteriorTarget.disabled = etapa === 1
    this.btnProximoTarget.classList.toggle('hidden', etapa === 5)
    this.btnSubmitTarget.classList.toggle('hidden', etapa !== 5)

    if (etapa >= 3) this.#atualizaBotaoSubmit()

    this.#escondeErro()
  }

  #validaEtapaAtual() {
    if (this.etapaValue === 1) {
      const funcId = this.funcionarioIdTarget.value.trim()
      const tipo   = this.tipoRescisaoTarget.value.trim()
      const data   = this.dataPretendidaTarget.value.trim()
      const aviso  = this.avisoPrevioTarget.value.trim()
      if (!funcId || !tipo || !data || !aviso) {
        this.#exibeErro('Preencha todos os campos obrigatórios antes de continuar.')
        return false
      }
      return true
    }

    if (this.etapaValue === 3) {
      const todosChecked = this.cienciaCheckboxTargets.every(cb => cb.checked)
      const justOk = !this.#requerJustificativa || this.justificativaTarget.value.trim().length >= 10
      const docOk  = this.#documentoObrigatorioAnexado()
      if (!todosChecked || !justOk) {
        this.#exibeErro('Confirme todos os itens de ciência antes de continuar.')
        return false
      }
      if (!docOk) {
        this.#exibeErro('Anexe o documento obrigatório para este tipo de rescisão antes de continuar.')
        return false
      }
      return true
    }

    return true
  }

  async #carregaPreAnalise() {
    this.#escondeErro()
    this.loadingIndicatorTarget.classList.remove('hidden')
    this.btnProximoTarget.disabled = true

    const body = new URLSearchParams({
      rm_funcionario_id: this.funcionarioIdTarget.value,
      tipo_rescisao:     this.tipoRescisaoTarget.value,
      data_pretendida:   this.dataPretendidaTarget.value,
      aviso_previo:      this.avisoPrevioTarget.value,
    })

    const csrfMeta = document.querySelector('meta[name="csrf-token"]')
    const csrf     = csrfMeta ? csrfMeta.getAttribute('content') : ''

    try {
      const resp = await fetch(this.preAnaliseUrlValue, {
        method: 'POST',
        headers: { 'X-CSRF-Token': csrf, 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
        body,
      })

      const json = await resp.json()

      if (!resp.ok) {
        this.#exibeErro(json.erro || 'Erro ao consultar dados do funcionário.')
        return false
      }

      this.#preencheDados(json.dados || {})
      this.#preencheAlertas(json.alertas || [])
      this.preAnaliseJsonTarget.value      = JSON.stringify(json.dados || {})
      this.alertasJsonTarget.value         = JSON.stringify(json.alertas || [])
      this.alertasExibidosJsonTarget.value = JSON.stringify((json.alertas || []).map(a => a.codigo))
      this.#preAnaliseSucesso = true
      return true
    } catch {
      this.#exibeErro('Erro de conexão. Tente novamente.')
      return false
    } finally {
      this.loadingIndicatorTarget.classList.add('hidden')
      this.btnProximoTarget.disabled = false
    }
  }

  #preencheDados(d) {
    const fmt = (v, prefix = '') => (v != null && v !== '') ? `${prefix}${v}` : '-'
    const brl = v => (v != null && v !== '') ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v) : '-'

    this.dadoNomeTarget.textContent          = fmt(d.nome)
    this.dadoCargoTarget.textContent         = fmt(d.cargo)
    this.dadoAdmissaoTarget.textContent      = fmt(d.data_admissao)
    this.dadoTempoCasaTarget.textContent     = fmt(d.tempo_de_casa)
    this.dadoSituacaoTarget.textContent      = fmt(d.situacao)
    this.dadoFeriasVencidasTarget.textContent = d.ferias_vencidas_dias > 0
      ? `${d.ferias_vencidas_dias} dia(s)`
      : 'Sem férias vencidas'
    this.dadoVencimentoFeriasTarget.textContent = fmt(d.data_vencimento_ferias)
    this.dadoSalarioTarget.textContent = brl(d.salario_base)
    this.dadoFgtsTarget.textContent    = brl(d.saldo_fgts)

    // VA - mostra linha apenas se > 0
    if (this.hasDadoVaRowTarget) {
      const temVa = d.valor_va > 0
      this.dadoVaRowTarget.classList.toggle('hidden', !temVa)
      this.dadoVaTarget.textContent = brl(d.valor_va)
    }

    // VR - mostra linha apenas se > 0
    if (this.hasDadoVrRowTarget) {
      const temVr = d.valor_vale_refeicao > 0
      this.dadoVrRowTarget.classList.toggle('hidden', !temVr)
      this.dadoVrTarget.textContent = brl(d.valor_vale_refeicao)
    }

    // Cesta - mostra linha apenas se > 0
    if (this.hasDadoCestaRowTarget) {
      const temCesta = d.valor_vale_cesta_basica > 0
      this.dadoCestaRowTarget.classList.toggle('hidden', !temCesta)
      this.dadoCestaTarget.textContent = brl(d.valor_vale_cesta_basica)
    }

    // VT - mostra linha apenas se > 0
    if (this.hasDadoVtRowTarget) {
      const temVt = d.valor_vt > 0
      this.dadoVtRowTarget.classList.toggle('hidden', !temVt)
      if (this.hasDadoVtTarget) this.dadoVtTarget.textContent = brl(d.valor_vt)
    }

    if (d.consultado_em) {
      const dt = new Date(d.consultado_em)
      this.consultadoEmTarget.textContent = `Dados consultados em: ${dt.toLocaleString('pt-BR')}`
    }

    if (d.afastado) {
      this.alertaAfastamentoTarget.classList.remove('hidden')
      this.textoSituacaoTarget.textContent = `Situação atual: ${d.situacao || 'Afastado'}`
    } else {
      this.alertaAfastamentoTarget.classList.add('hidden')
    }

    this.#atualizaAlertaBeneficios(d)
  }

  #atualizaAlertaBeneficios(d) {
    if (!this.hasAlertaBeneficiosContainerTarget) return

    const tipo = this.hasTipoRescisaoTarget ? this.tipoRescisaoTarget.value : ''
    if (tipo !== 'pedido_colaborador') {
      this.alertaBeneficiosContainerTarget.classList.add('hidden')
      return
    }

    const brl = v => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v)
    const beneficios = []

    if (d.valor_vt > 0)               beneficios.push(`Vale Transporte (VT): ${brl(d.valor_vt)}`)
    if (d.valor_va > 0)               beneficios.push(`Vale Alimentação (VA): ${brl(d.valor_va)}`)
    if (d.valor_vale_refeicao > 0)    beneficios.push(`Vale Refeição (VR): ${brl(d.valor_vale_refeicao)}`)
    if (d.valor_vale_cesta_basica > 0) beneficios.push(`Vale Cesta Básica: ${brl(d.valor_vale_cesta_basica)}`)

    if (beneficios.length === 0) {
      this.alertaBeneficiosContainerTarget.classList.add('hidden')
      return
    }

    this.alertaBeneficiosContainerTarget.classList.remove('hidden')
    if (this.hasAlertaBeneficiosListTarget) {
      this.alertaBeneficiosListTarget.innerHTML = beneficios
        .map(b => `<li>${b}</li>`)
        .join('')
    }
  }

  #preencheAlertas(alertas) {
    this.#alertas = alertas
    const container = this.alertasContainerTarget
    container.innerHTML = ''

    if (alertas.length === 0) {
      this.semAlertasTarget.classList.remove('hidden')
      container.classList.add('hidden')
      return
    }

    this.semAlertasTarget.classList.add('hidden')
    container.classList.remove('hidden')

    const tpl = this.alertaTemplateTarget
    alertas.forEach(alerta => {
      const clone      = tpl.content.cloneNode(true)
      const div        = clone.querySelector('.alerta-item')
      const visualCfg  = alerta.tipo_visual ? (TIPO_VISUAL_CLASSES[alerta.tipo_visual] || null) : null
      const cfg        = visualCfg || SEVERIDADE_CLASSES[alerta.severidade] || SEVERIDADE_CLASSES.alerta
      const label      = visualCfg ? (visualCfg.label || alerta.severidade) : (SEVERIDADE_LABEL[alerta.severidade] || alerta.severidade)

      div.classList.add(...cfg.border, ...cfg.bg)
      div.dataset.severidade                                = alerta.severidade
      clone.querySelector('.alerta-icon').innerHTML         = cfg.icon
      clone.querySelector('.alerta-badge').classList.add(...cfg.badge)
      clone.querySelector('.alerta-badge').textContent      = label
      clone.querySelector('.alerta-titulo').textContent     = alerta.titulo
      clone.querySelector('.alerta-mensagem').textContent   = alerta.mensagem

      if (alerta.requer_ciencia) {
        clone.querySelector('.alerta-ciencia-note').classList.remove('hidden')
      }

      container.appendChild(clone)
    })

    this.#injetaCheckboxesCiencia()
  }

  #injetaCheckboxesCiencia() {
    const tpl       = this.checkboxAlertaTemplateTarget
    const container = this.checkboxesContainerTarget
    container.querySelectorAll('.alerta-checkbox-item').forEach(el => el.remove())

    const alertasComCiencia = this.#alertas.filter(a => a.requer_ciencia)
    alertasComCiencia.forEach(alerta => {
      const clone   = tpl.content.cloneNode(true)
      const input   = clone.querySelector('input[type="checkbox"]')
      input.value   = `ciencia_${alerta.codigo}`
      clone.querySelector('.alerta-checkbox-label').textContent = `Ciente sobre: ${alerta.titulo}`
      container.insertBefore(clone, container.firstChild)
    })

    const temImpeditivo = this.#alertas.some(a => a.severidade === 'impeditivo')
    this.#requerJustificativa = temImpeditivo ||
      TIPOS_COM_JUSTIFICATIVA_OBRIGATORIA.includes(this.tipoRescisaoTarget.value)

    this.justificativaContainerTarget.classList.toggle('hidden', !this.#requerJustificativa)
    this.#atualizaBotaoSubmit()
  }

  #preparaEtapa4() {
    const tipo = this.tipoRescisaoTarget.value
    const codigoSugerido = FGTS_POR_TIPO[tipo] ?? ''
    if (this.codigoFgtsTarget.value === '') {
      this.codigoFgtsTarget.value = codigoSugerido
    }

    // Exibe o container do código FGTS apenas para tipos com direito de saque
    if (this.hasCodigoFgtsContainerTarget) {
      this.codigoFgtsContainerTarget.classList.toggle('hidden', !TIPOS_COM_CODIGO_FGTS.includes(tipo))
    }

    const precisaMotivo = TIPOS_COM_MOTIVO_OBRIGATORIO.includes(tipo)
    this.motivoContainerTarget.classList.toggle('hidden', !precisaMotivo)

    this.#preencheResumoEtapa4()
    this.#renderizaAlertasTipoEtapa4()
    this.#toggleVerbasRescisorias()
    this.#preencheDescontosValores()
    this.#atualizaBotaoSubmit()
  }

  #preencheResumoEtapa4() {
    const select  = this.hasTipoRescisaoTarget  ? this.tipoRescisaoTarget  : null
    const dateEl  = this.hasDataPretendidaTarget ? this.dataPretendidaTarget : null
    const avisoEl = this.hasAvisoPrevioTarget    ? this.avisoPrevioTarget   : null

    if (this.hasResumoTipoTarget && select) {
      const opt = select.options[select.selectedIndex]
      this.resumoTipoTarget.textContent = opt ? opt.text : '-'
    }

    if (this.hasResumoDataTarget && dateEl) {
      const raw = dateEl.value
      if (raw) {
        const [y, m, d] = raw.split('-')
        this.resumoDataTarget.textContent = `${d}/${m}/${y}`
      } else {
        this.resumoDataTarget.textContent = '-'
      }
    }

    if (this.hasResumoAvisoTarget && avisoEl) {
      const opt = avisoEl.options[avisoEl.selectedIndex]
      this.resumoAvisoTarget.textContent = opt ? opt.text : '-'
    }

    this.#preencheImpedimentos()
  }

  #preencheImpedimentos() {
    const dados = JSON.parse(this.preAnaliseJsonTarget.value || '{}')
    const brl   = v => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v)

    const aplica = (target, texto, temProblema) => {
      if (!target) return
      target.classList.remove('text-green-700', 'text-amber-700')
      target.classList.add(temProblema ? 'text-amber-700' : 'text-green-700')
      target.textContent = texto
    }

    // Férias
    const diasFerias = dados.ferias_vencidas_dias || 0
    aplica(
      this.hasImpedimentoFeriasTarget ? this.impedimentoFeriasTarget : null,
      diasFerias > 0 ? `${diasFerias} dia(s) vencido(s)` : 'Sem férias vencidas',
      diasFerias > 0
    )

    // Benefícios
    const partesBeneficios = []
    if (dados.valor_va > 0)               partesBeneficios.push(`VA ${brl(dados.valor_va)}`)
    if (dados.valor_vale_refeicao > 0)    partesBeneficios.push(`VR ${brl(dados.valor_vale_refeicao)}`)
    if (dados.valor_vale_cesta_basica > 0) partesBeneficios.push(`Cesta ${brl(dados.valor_vale_cesta_basica)}`)
    if (dados.valor_vt > 0)               partesBeneficios.push(`VT ${brl(dados.valor_vt)}`)
    aplica(
      this.hasImpedimentoBeneficiosTarget ? this.impedimentoBeneficiosTarget : null,
      partesBeneficios.length > 0 ? partesBeneficios.join(' · ') : 'Nenhum ativo',
      partesBeneficios.length > 0
    )

    // Consignados
    const countConsig = dados.consignados_ativos_count || 0
    const valorConsig = dados.consignados_valor_mensal || 0
    aplica(
      this.hasImpedimentoConsignadosTarget ? this.impedimentoConsignadosTarget : null,
      countConsig > 0 ? `${countConsig} ativo(s) · ${brl(valorConsig)}/mês` : 'Nenhum ativo',
      countConsig > 0
    )
  }

  #renderizaAlertasTipoEtapa4() {
    if (!this.hasEtapa4AlertasTarget) return
    const alertas = JSON.parse(this.alertasJsonTarget.value || '[]')
    const informativos = alertas.filter(a => !a.requer_ciencia)
    const container = this.etapa4AlertasTarget
    container.innerHTML = ''

    if (informativos.length === 0) {
      container.classList.add('hidden')
      return
    }

    container.classList.remove('hidden')
    const header = document.createElement('p')
    header.className = 'text-[10px] font-semibold text-gray-400 uppercase tracking-wide mb-2'
    header.textContent = 'Atenção para este tipo de rescisão'
    container.appendChild(header)

    const list = document.createElement('ul')
    list.className = 'space-y-1.5'
    informativos.forEach(alerta => {
      const visualCfg = alerta.tipo_visual ? (TIPO_VISUAL_CLASSES[alerta.tipo_visual] || null) : null
      const cfg = visualCfg || SEVERIDADE_CLASSES[alerta.severidade] || SEVERIDADE_CLASSES.alerta
      const li = document.createElement('li')
      li.className = ['flex items-start gap-2 rounded-md px-3 py-2 text-sm', ...cfg.bg, ...cfg.border].join(' ')
      li.innerHTML = `<span class="shrink-0 mt-0.5">${cfg.icon}</span><span class="text-gray-700">${alerta.mensagem}</span>`
      list.appendChild(li)
    })
    container.appendChild(list)
  }

  #toggleVerbasRescisorias() {
    if (!this.hasVerbasRescisoriasContainerTarget) return
    const tipo = this.hasTipoRescisaoTarget ? this.tipoRescisaoTarget.value : ''
    this.verbasRescisoriasContainerTarget.classList.toggle('hidden', tipo !== 'demissao_sem_justa_causa')
  }

  #atualizaGuiaProcesso(tipo) {
    if (!this.hasGuiaProcessoTarget) return
    this.guiaProcessoTargets.forEach(el => {
      el.classList.toggle('hidden', el.dataset.tipo !== tipo)
    })
  }

  #preencheDescontosValores() {
    const dados = JSON.parse(this.preAnaliseJsonTarget.value || '{}')
    const brl   = v => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v)

    const configura = (temValor, rowTarget, valorTarget, hintTarget, valor, checkboxTarget) => {
      if (!rowTarget) return
      rowTarget.classList.toggle('hidden', !temValor)
      if (!temValor) return
      if (hintTarget) hintTarget.textContent = `Carga do mês: ${brl(valor)}`
      if (valorTarget && !valorTarget.value) valorTarget.value = Number(valor).toFixed(2)
      if (checkboxTarget) valorTarget.disabled = !checkboxTarget.checked
    }

    configura(
      dados.valor_vt > 0,
      this.hasDescontoVtRowTarget    ? this.descontoVtRowTarget    : null,
      this.hasDescontoVtValorTarget  ? this.descontoVtValorTarget  : null,
      this.hasDescontoVtHintTarget   ? this.descontoVtHintTarget   : null,
      dados.valor_vt,
      this.hasDescontoVtCheckboxTarget ? this.descontoVtCheckboxTarget : null,
    )

    configura(
      dados.valor_va > 0,
      this.hasDescontoVaRowTarget    ? this.descontoVaRowTarget    : null,
      this.hasDescontoVaValorTarget  ? this.descontoVaValorTarget  : null,
      this.hasDescontoVaHintTarget   ? this.descontoVaHintTarget   : null,
      dados.valor_va,
      this.hasDescontoVaCheckboxTarget ? this.descontoVaCheckboxTarget : null,
    )

    configura(
      dados.valor_vale_refeicao > 0,
      this.hasDescontoVrRowTarget    ? this.descontoVrRowTarget    : null,
      this.hasDescontoVrValorTarget  ? this.descontoVrValorTarget  : null,
      this.hasDescontoVrHintTarget   ? this.descontoVrHintTarget   : null,
      dados.valor_vale_refeicao,
      this.hasDescontoVrCheckboxTarget ? this.descontoVrCheckboxTarget : null,
    )
  }

  #preparaEtapa3Docs() {
    const tipo    = this.hasTipoRescisaoTarget ? this.tipoRescisaoTarget.value : ''
    const prefixo = TIPO_PARA_PREFIXO_DOC[tipo] ?? null

    Object.values(TIPO_PARA_PREFIXO_DOC).forEach(p => {
      const cap = p[0].toUpperCase() + p.slice(1)
      if (this[`has${cap}SectionTarget`]) {
        this[`${p}SectionTarget`].classList.toggle('hidden', p !== prefixo)
      }
      // exibe indicador de arquivo existente apenas na seção ativa
      if (this[`has${cap}ExistenteTarget`]) {
        const campo   = PREFIXO_PARA_CAMPO_DOC[p]
        const existente = p === prefixo && !!campo && campo === this.docExistenteValue
        this[`${p}ExistenteTarget`].classList.toggle('hidden', !existente)
      }
    })

    // Encaminhamento exame demissional — só para demissão sem justa causa
    if (this.hasEncaminhamentoExameSectionTarget) {
      this.encaminhamentoExameSectionTarget.classList.toggle('hidden', tipo !== 'demissao_sem_justa_causa')
    }

    this.#atualizaBotaoSubmit()
  }

  #preparaRevisao() {
    if (this.hasRevisaoTipoTarget && this.hasTipoRescisaoTarget) {
      const sel = this.tipoRescisaoTarget
      const opt = sel.options[sel.selectedIndex]
      this.revisaoTipoTarget.textContent = opt ? opt.text : '-'
    }

    const tipo    = this.hasTipoRescisaoTarget ? this.tipoRescisaoTarget.value : ''
    const prefixo = TIPO_PARA_PREFIXO_DOC[tipo] ?? null
    const cap     = prefixo ? prefixo[0].toUpperCase() + prefixo.slice(1) : null
    const input   = cap && this[`has${cap}InputTarget`] ? this[`${prefixo}InputTarget`] : null
    const temDoc  = input && input.files.length > 0

    // sem documento obrigatório para este tipo
    if (this.hasRevisaoDocVazioTarget) {
      this.revisaoDocVazioTarget.classList.toggle('hidden', !!prefixo)
    }

    const campo = prefixo ? (PREFIXO_PARA_CAMPO_DOC[prefixo] ?? null) : null
    const temDocServidor = !temDoc && !!campo && campo === this.docExistenteValue

    if (this.hasRevisaoDocItemTarget) {
      this.revisaoDocItemTarget.classList.toggle('hidden', !temDoc && !temDocServidor)

      if (temDoc) {
        const arquivo = input.files[0]
        if (this.hasRevisaoDocLabelTarget)    this.revisaoDocLabelTarget.textContent    = input.dataset.docLabel || ''
        if (this.hasRevisaoDocNomeTextoTarget) this.revisaoDocNomeTextoTarget.textContent = arquivo.name
        if (this.hasRevisaoDocLinkTarget) {
          if (this.#objectUrl) URL.revokeObjectURL(this.#objectUrl)
          this.#objectUrl = URL.createObjectURL(arquivo)
          this.revisaoDocLinkTarget.href = this.#objectUrl
          this.revisaoDocLinkTarget.classList.remove('hidden')
        }
      } else if (temDocServidor) {
        if (this.hasRevisaoDocLabelTarget)    this.revisaoDocLabelTarget.textContent    = input ? (input.dataset.docLabel || '') : ''
        if (this.hasRevisaoDocNomeTextoTarget) this.revisaoDocNomeTextoTarget.textContent = 'Documento salvo anteriormente'
        if (this.hasRevisaoDocLinkTarget) {
          const url = this.docExistenteUrlValue
          if (url) {
            this.revisaoDocLinkTarget.href = url
            this.revisaoDocLinkTarget.classList.remove('hidden')
          } else {
            this.revisaoDocLinkTarget.classList.add('hidden')
          }
        }
      }
    }

    this.#atualizaBotaoSubmit()
  }

  #documentoObrigatorioAnexado() {
    const tipo    = this.hasTipoRescisaoTarget ? this.tipoRescisaoTarget.value : ''
    const prefixo = TIPO_PARA_PREFIXO_DOC[tipo]
    if (!prefixo) return true
    const cap = prefixo[0].toUpperCase() + prefixo.slice(1)
    if (this[`has${cap}InputTarget`] && this[`${prefixo}InputTarget`].files.length > 0) return true
    // aceita se já há um arquivo salvo no servidor (edição de rascunho)
    const campo = PREFIXO_PARA_CAMPO_DOC[prefixo]
    return !!campo && campo === this.docExistenteValue
  }

  #atualizaBotaoSubmit() {
    if (this.etapaValue === 3) {
      const todosChecked = this.cienciaCheckboxTargets.every(cb => cb.checked)
      const justificativaOk = !this.#requerJustificativa ||
        this.justificativaTarget.value.trim().length >= 10
      this.btnSubmitTarget.disabled = !(todosChecked && justificativaOk)
      return
    }

    if (this.etapaValue === 4) {
      const tipo     = this.tipoRescisaoTarget.value
      const motivoOk = !TIPOS_COM_MOTIVO_OBRIGATORIO.includes(tipo) ||
                       this.motivoDetalhadoTarget.value.trim().length >= 10
      this.btnSubmitTarget.disabled = !motivoOk
      return
    }

    if (this.etapaValue === 5) {
      this.btnSubmitTarget.disabled = false
    }
  }

  #etapaCompleta(n) {
    switch (n) {
      case 1: {
        const funcId = this.hasFuncionarioIdTarget ? this.funcionarioIdTarget.value.trim() : ''
        const tipo   = this.hasTipoRescisaoTarget  ? this.tipoRescisaoTarget.value.trim()  : ''
        const data   = this.hasDataPretendidaTarget ? this.dataPretendidaTarget.value.trim() : ''
        const aviso  = this.hasAvisoPrevioTarget   ? this.avisoPrevioTarget.value.trim()   : ''
        return !!(funcId && tipo && data && aviso)
      }
      case 2:
        return this.#preAnaliseSucesso
      case 3: {
        if (!this.hasCienciaCheckboxTarget) return false
        const todosChecked = this.cienciaCheckboxTargets.every(cb => cb.checked)
        const justOk = !this.#requerJustificativa ||
          (this.hasJustificativaTarget && this.justificativaTarget.value.trim().length >= 10)
        return todosChecked && justOk && this.#documentoObrigatorioAnexado()
      }
      case 4: {
        const tipo = this.hasTipoRescisaoTarget ? this.tipoRescisaoTarget.value : ''
        return !TIPOS_COM_MOTIVO_OBRIGATORIO.includes(tipo) ||
          (this.hasMotivoDetalhadoTarget && this.motivoDetalhadoTarget.value.trim().length >= 10)
      }
      case 5:
        return true
      default:
        return false
    }
  }

  #exibeErro(msg) {
    this.erroGlobalTarget.textContent = msg
    this.erroGlobalTarget.classList.remove('hidden')
  }

  #escondeErro() {
    this.erroGlobalTarget.classList.add('hidden')
    this.erroGlobalTarget.textContent = ''
  }
}

// ─── SVG helpers ─────────────────────────────────────────────────────────────

function checkIcon() {
  return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-4 h-4"><path fill-rule="evenodd" d="M12.416 3.376a.75.75 0 0 1 .208 1.04l-5 7.5a.75.75 0 0 1-1.154.114l-3-3a.75.75 0 0 1 1.06-1.06l2.353 2.353 4.493-6.74a.75.75 0 0 1 1.04-.207Z" clip-rule="evenodd"/></svg>'
}

function iconCircleX(cls) {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5 ${cls}"><path fill-rule="evenodd" d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM8.28 7.22a.75.75 0 0 0-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 1 0 1.06 1.06L10 11.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L11.06 10l1.72-1.72a.75.75 0 0 0-1.06-1.06L10 8.94 8.28 7.22Z" clip-rule="evenodd"/></svg>`
}

function iconWarning(cls) {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5 ${cls}"><path fill-rule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495ZM10 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 5Zm0 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" clip-rule="evenodd"/></svg>`
}

function iconBan(cls) {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5 ${cls}"><path fill-rule="evenodd" d="M5.965 4.904l9.131 9.131a7 7 0 0 0-9.131-9.131Zm8.07 10.196L4.904 5.965a7 7 0 0 0 9.131 9.131ZM4.343 4.343a8 8 0 1 1 11.314 11.314A8 8 0 0 1 4.343 4.343Z" clip-rule="evenodd"/></svg>`
}

function iconInfo(cls) {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5 ${cls}"><path fill-rule="evenodd" d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 9a.75.75 0 0 0 0 1.5h.253a.25.25 0 0 1 .244.304l-.459 2.066A1.75 1.75 0 0 0 10.747 15H11a.75.75 0 0 0 0-1.5h-.253a.25.25 0 0 1-.244-.304l.459-2.066A1.75 1.75 0 0 0 9.253 9H9Z" clip-rule="evenodd"/></svg>`
}
